module.exports = __webpack_public_path__ + "img/facts_1941.a17da646.jpg";